import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { Tag } from 'antd';
import { connect } from 'react-redux';
import ReactPlayer from 'react-player';
import { DownOutlined } from '@ant-design/icons';

import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../../ChartCalls';
import { ErrorComponent, NoRecordComponent } from '../../../Utils';
import { config } from '../../../constant';
import { videoMock } from '../../../../Mock/MockJson';

import berth from './images/berth.jpg';
import berth1 from './images/berth1.jpg';
import berth2 from './images/berth2.jpg';
import berth11 from './images/berth11.jpg';

const VideoComponent = (props) => {
  const setCurrentVideo = useState('');
  const [imagesList, setImagesList] = useState([]);
  const [currentImage, setCurrentImage] = useState(berth);
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  const [requestCheck, setRequestCheck] = useState(true);
  const abortController = useRef(new window.AbortController());

  useEffect(() => {
    const getData = async () => {
      setRequestCheck(false);
      let json = [];
      let { graphprops } = props;
      let errorInAPI = false;
      let noDataInDB = false;

      if (graphprops && graphprops.enableMock) {
        json = videoMock;
        setRequestCheck(true);
      } else {
        // Logic to determine which data to fetch
        if (shouldFetchWithSelection(graphprops)) {
          json = await getChartDataWithSelection({
            graphprops,
            DeviceCode: props.DeviceCode,
            selectionDate: props.selectionDate,
            selectionMonth: props.selectionMonth,
            selectionWeek: props.selectionWeek,
            shift: props.shift,
            selectionDateRange: props.selectionDateRange,
            dayMonthYear: props.dayMonthYear,
            abortController,
            dropdownSelection: props.dropdownSelection,
            dashboardPayload: props.dashboardPayload,
            AssetCode: props.AssetCode,
            selectionDateLive: props.selectionDateLive,
            currentTimeZone: props.currentTimeZone
          });
          setRequestCheck(true);
        } else {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController,
            dropdownSelection: props.dropdownSelection,
            DeviceCode: props.DeviceCode,
            TimeZone: props.currentTimeZone
          });
          setRequestCheck(true);
        }
      }

      if ((json && json.message) || (Array.isArray(json) && json.length === 0 && !graphprops.enableMock)) {
        if (json.message) {
          errorInAPI = true;
        } else if (json.length === 0) {
          noDataInDB = true;
        }
      } else {
        setImagesList([
          { id: 1, imageUrl: berth, videoUrl: 'https://icedrive.net/s/NFvRu9597CVYx9uigNG2jTufyhwA' },
          { id: 2, imageUrl: berth1, videoUrl: 'https://icedrive.net/s/NFvRu9597CVYx9uigNG2jTufyhwA' },
          { id: 3, imageUrl: berth2, videoUrl: 'https://icedrive.net/s/NFvRu9597CVYx9uigNG2jTufyhwA' },
          { id: 4, imageUrl: berth11, videoUrl: 'https://icedrive.net/s/NFvRu9597CVYx9uigNG2jTufyhwA' }
        ]);
        setRefreshDateTime(moment());
      }

      setErrorInAPI(errorInAPI);
      setNoDataInDB(noDataInDB);
    };

    const shouldFetchWithSelection = (graphprops) => {
      return (
        (graphprops && (graphprops.DashboardLevelSelection === 'datePicker' || graphprops.GraphLevelSelection === 'datePicker') && props.selectionDate) ||
        (graphprops && (graphprops.DashboardLevelSelection === 'monthPicker' || graphprops.GraphLevelSelection === 'monthPicker') && props.selectionMonth) ||
        (graphprops && (graphprops.DashboardLevelSelection === 'weakPicker' || graphprops.GraphLevelSelection === 'weakPicker') && props.selectionWeek) ||
        (graphprops && (graphprops.DashboardLevelSelection === 'shiftPicker' || graphprops.GraphLevelSelection === 'shiftPicker') && props.shift) ||
        (graphprops && (graphprops.DashboardLevelSelection === 'dateRangePicker' || graphprops.GraphLevelSelection === 'date RangePicker') && props.selectionDateRange) ||
        (graphprops && (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' || graphprops.GraphLevelSelection === 'dateMonthYearPicker') && props.dayMonthYear) ||
        (graphprops && graphprops.dashboardType === 'dynamic') ||
        (graphprops.dashboardType === 'dropdownHide' && props.DeviceCode) ||
        (graphprops && graphprops.dashboardType === 'hierarchy' && props.dropdownSelection) ||
        (graphprops && props.dashboardPayload) ||
        (graphprops && graphprops.treeExists === 'true' && props.AssetCode)
      );
    };

    getData();

    const refreshTime = props.graphprops.refreshTime ? props.graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    const timeTicket = setInterval(() => {
      if (requestCheck) {
        getData();
      }
    }, refreshTime);

    return () => {
      abortController.current.abort();
      clearInterval(timeTicket);
    };
  }, [props]);

  const openImageViewer = (image, video) => {
    setCurrentImage(image);
    setCurrentVideo(video);
    // Logic to open the viewer can be added here
  };

  return (
    <>
      {props.graphprops && props.graphprops.checked ? (
        <Tag color="blue" style={{ float: '', position: 'relative', zIndex: '2' }}>
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB || errorInAPI ? (
        noDataInDB ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'row-reverse' }}>
          <div style={{ width: '40%', margin: '5px 10px' }}>
            {imagesList && Array.isArray(imagesList) && imagesList.map((src, index) => (
              <img
                src={src.imageUrl}
                onClick={() => openImageViewer(src.imageUrl, src.videoUrl)}
                width="50%"
                height="150"
                key={index}
                style={{ margin: '5px 0px', padding: '2px' }}
                alt=""
              />
            ))}
          </div>
          <div style={{ marginTop: '10px', marginLeft: '30px' }}>
            <ReactPlayer
              width="810px"
              height="350px"
              url={currentImage}
              config={{
                file: {
                  attributes: {
                    poster: currentImage,
                  },
                },
              }}
              pip
            />
          </div>
        </div>
      )}
      {props.reportName && props.excelDownload === 'true' ? (
        <a
          href={`${config.excelDownloadUrl}/${props.reportName}`}
          style={{ fontWeight: 'bold' }}
        >
          <DownOutlined
            style={{
              fontWeight: 'bold',
              marginRight: '25px',
              marginTop: '6px'
            }}
          />
        </a>
      ) : null}
    </>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  currentTimeZone: state.LayoutReducer.currentTimeZone,
  selectedThemeing: state.ThemeReducer.themeing
});

export default connect(mapStateToProps)(VideoComponent);